export default __webpack_public_path__ + "static/media/who_logo.5ed94ff9.svg";